import { useReactiveVar } from "@apollo/client";
import { menuLanguageVersionVar } from "@me-team/host/main/menuLanguageVersions/state";
import { useGetLanguageVersionsForMenuQuery } from "@me-team/host/main/menuLanguageVersions/graphql/menuLanguageVersions.hooks";

export const useMenuLanguagesData = (companyId: number | null | undefined) => {
    const selectedLanguageCode = useReactiveVar(menuLanguageVersionVar);

    const { data, loading } = useGetLanguageVersionsForMenuQuery({
        variables: { companyId: Number(companyId) },
        skip: !companyId,
        fetchPolicy: "cache-first",
        context: { errorType: "local" },
    });

    const primaryLanguage = data?.user?.company?.primaryLanguage ?? null;
    const languages = data?.user?.company?.languages ?? [];

    return {
        loading,
        selectedLanguageCode: selectedLanguageCode?.trim() || null,
        primaryLanguage,
        languages,
    };
};
